function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fzojo0i6ca"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4457",
    style: {
      fill: "#f79009"
    },
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5e255i5unb"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3916",
    style: {
      stroke: "#032541",
      strokeWidth: ".2px",
      fill: "#f79009"
    },
    d: "M0 0h17.778v17.778H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#fzojo0i6ca)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#5e255i5unb)"
    },
    "data-name": "Mask Group 17852"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 24753",
    d: "M1.9 19.656v-1.62a2.008 2.008 0 0 1 .31-1.095 1.889 1.889 0 0 1 .862-.733 13.664 13.664 0 0 1 2.267-.793 8.888 8.888 0 0 1 2.077-.241 8.778 8.778 0 0 1 2.069.241 13.784 13.784 0 0 1 2.258.793 1.941 1.941 0 0 1 .871.733 1.967 1.967 0 0 1 .319 1.095v1.62zm12.067 0v-1.62a2.79 2.79 0 0 0-.552-1.784 4.039 4.039 0 0 0-1.448-1.129 17.093 17.093 0 0 1 2.241.405 7.9 7.9 0 0 1 1.707.612 2.667 2.667 0 0 1 .9.81 1.89 1.89 0 0 1 .328 1.086v1.62zm-6.55-5.534a2.48 2.48 0 0 1-2.586-2.586A2.48 2.48 0 0 1 7.417 8.95 2.48 2.48 0 0 1 10 11.536a2.48 2.48 0 0 1-2.586 2.586zm6.206-2.586a2.48 2.48 0 0 1-2.586 2.586 3.853 3.853 0 0 1-.422-.026 1.831 1.831 0 0 1-.423-.096 2.829 2.829 0 0 0 .629-1.06 4.315 4.315 0 0 0 .215-1.4 4.01 4.01 0 0 0-.215-1.371 3.669 3.669 0 0 0-.629-1.095 3.668 3.668 0 0 1 .422-.086 2.888 2.888 0 0 1 .422-.034 2.48 2.48 0 0 1 2.586 2.586zM2.934 18.621H11.9v-.586a.985.985 0 0 0-.164-.534.9.9 0 0 0-.405-.362 11.643 11.643 0 0 0-2.087-.739 8.329 8.329 0 0 0-1.827-.19 8.447 8.447 0 0 0-1.836.19 11.538 11.538 0 0 0-2.095.741.854.854 0 0 0-.4.362 1.026 1.026 0 0 0-.155.534zm4.482-5.534a1.552 1.552 0 1 0 0-3.1 1.552 1.552 0 1 0 0 3.1z",
    transform: "translate(1.12 -3.89)",
    style: {
      fill: "#f79009"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.6d4e78f08259b95338f3e564798fd3f0.svg";
export { ForwardRef as ReactComponent };